<template>
  <div id="app">
    <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
<style lang="css">
    html,body{
      margin: 0px;
      padding: 0px;
      min-width: 1200px;
      height: 100%;
      color: #333333;
      /*background-color:#f5f5f5;*/
    }
    h1, h2 {
      font-weight: normal;
    }
    ul {
      list-style-type: none;
      padding: 0;
      list-style: none;
    }
    li {
      display: inline-block;
      margin: 0 10px;
      text-decoration: none;
      list-style: none;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue